<template>
  <div class="user-wrap">
    <!--修改手机号-->
    <div class="title">
      <span class="num">1</span>修改手机号
    </div>
    <div class="repwd">
      <el-form ref="rePwdForm" :model="rePwdForm" :rules="rules" label-width="110px" class="repwd-form" :inline-message="true">
        <el-form-item label="原手机号：" prop="oldphone">
          <el-input v-model="rePwdForm.oldphone" placeholder="请输入原手机号" :disabled="true" >
            <!-- <i slot="suffix" class="el-icon-view" ref="oldicon" @click="showoldPwd"></i> -->
          </el-input>
        </el-form-item>
        <el-form-item label="新手机号：" prop="newphone">
          <el-input v-model="rePwdForm.newphone" placeholder="请输入新手机号">
            <!-- <i slot="suffix" class="el-icon-view" ref="icon" @click="showPwd"></i> -->
          </el-input>
        </el-form-item>
        <el-form-item label="验证码：" prop="phonecode">
          <el-input style="width: 150px;" v-model="rePwdForm.phonecode" placeholder="请输入验证码">
            <!-- <i slot="suffix" class="el-icon-view" @click="shownewPwd"></i> -->
          </el-input>
          <el-button style="width: 106px;" type="primary" :disabled="!Verification" @click="getphonecode">{{Verification==true?'获取验证码':timer + '秒后重新获取'}}</el-button>
          <!-- <el-button style="width: 100px;float: right;" type="primary" v-show="!Verification" disabled>
            <span>{{ timer }}</span>秒后重新获取
          </el-button> -->
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">确认</el-button>
          <el-button @click="onCancle">取消</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--公众号-->
    <div class="title">
      <span class="num">2</span>公众号
    </div>

    <el-row>
      <el-col :span="7">
        <div class="qrcode">
          <img src="../../../static/img/qrcode.jpg" width="180" />
        </div>
      </el-col>

    </el-row>
  </div>
</template>

<script>
import { getUserInfoCW,SendMessage,modifyUserPhone } from '@/api/login'
export default {
  name: 'Order.vue',
  data: function() {
    return {
      rePwdForm: {
        oldpwd: '',
        pwd: '',
        newPwdRe: '',
        oldphone:'',
        newphone:'',
        phonecode:''
      },
      password: 'password',
      oldpassword: 'password',
      newpassword: 'password',
      personData: [],
      Verification:true,
      timer:60,
      rules: {
        pwd: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          },
          {
            pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{6,16}$/,
            message: '必须由字母大小写、数字、符号组成，不包含空格，长度为6-16个字符'
          }
        ],
        newPwdRe: [
          {
            required: true,
            message: '请输入确认密码',
            trigger: 'blur'
          }
        ],
        oldpwd: [
          {
            required: true,
            message: '请输入旧密码',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created(){
    this.getData()
  },
  methods: {
    onCancle() {
      this.$router.push('/dashboard')
    },
    // showPwd() {
    //   if (this.password == 'password') this.password = ''
    //   else this.password = 'password'
    //   let e = this.$refs.icon
    //   this.password != ''
    //     ? e.setAttribute('style', 'color: #c0c4cc')
    //     : e.setAttribute('style', 'color: #409EFF')
    // },
    // showoldPwd() {
    //   if (this.oldpassword == 'password') this.oldpassword = ''
    //   else this.oldpassword = 'password'
    //   let e = this.$refs.oldicon
    //   this.oldpassword != ''
    //     ? e.setAttribute('style', 'color: #c0c4cc')
    //     : e.setAttribute('style', 'color: #409EFF')
    // },
    // shownewPwd() {
    //   if (this.newpassword == 'password') this.newpassword = ''
    //   else this.newpassword = 'password'
    //   let e = this.$refs.newicon
    //   this.newpassword != ''
    //     ? e.setAttribute('style', 'color: #c0c4cc')
    //     : e.setAttribute('style', 'color: #409EFF')
    // },
    // 执行修改密码--投保端
    // onSubmit() {
    //   this.$refs['rePwdForm'].validate(valid => {
    //     if (valid) {
    //       if (this.rePwdForm.pwd == this.rePwdForm.newPwdRe) {
    //         var body = {
    //           oldpwd: this.rePwdForm.oldpwd,
    //           password: this.rePwdForm.pwd
    //         }
    //         editUserPass(body)
    //           .then(res => {
    //             // console.log('修改密码返回结果1：' + JSON.stringify(res))
    //             if (res.code === 20000) {
    //               this.$confirm(
    //                 '你的密码已经修改成功，需要重新登录系统！',
    //                 '提示',
    //                 {
    //                   confirmButtonText: '确定',
    //                   cancelButtonText: '取消',
    //                   type: 'warning'
    //                 }
    //               )
    //                 .then(() => {
    //                   this.$router.push('/login')
    //                 })
    //                 .catch(() => {
    //                   this.$router.push('/login')
    //                 })
    //             } else {
    //               this.$message(JSON.stringify(res.msg))
    //             }
    //           })
    //           .catch(err => {
    //             // console.log('修改密码返回结果2：' + JSON.stringify(err))
    //             this.$message(JSON.stringify(err))
    //           })
    //       } else {
    //         this.$message('两次输入的新密码不相符')
    //       }
    //     } else {
    //       return false
    //     }
    //   })
    // },
    deleteRow(index, rows) {
      rows.splice(index, 1)
    },
    // 提交修改
    onSubmit(){
        if(this.rePwdForm.newphone == null || this.rePwdForm.newphone == '' || this.rePwdForm.newphone == undefined){
            this.$message('新手机号不能为空')
            return false
        }else{
            const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
            if (!reg.test(this.rePwdForm.newphone)){
                this.$message('请输入正确格式的手机号')
                return false
            }else{
                if(this.rePwdForm.newphone == this.rePwdForm.oldphone){
                    this.$message('新手机号不能和旧手机号相同')
                    return false
                }
            }
        }

        modifyUserPhone({
            verifyCode:this.rePwdForm.phonecode,
            phone:this.rePwdForm.newphone,
            usertype:2
        }).then(res=>{
            if(res.code == 20000){
                this.$message('修改成功,请重新登录')
                this.$router.push('/login')
            }else{
                this.$message('修改失败')
            }
        }).catch(e=>{
            this.$message('修改失败')
        })

    },
    // 获取验证码
    getphonecode(){
        if(this.rePwdForm.newphone == null || this.rePwdForm.newphone == '' || this.rePwdForm.newphone == undefined){
            this.$message('新手机号不能为空')
            return false
        }else{
            const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
            if (!reg.test(this.rePwdForm.newphone)){
                this.$message('请输入正确格式的手机号')
                return false
            }else{
                if(this.rePwdForm.newphone == this.rePwdForm.oldphone){
                    this.$message('新手机号不能和旧手机号相同')
                    return false
                }
            }
        }
        SendMessage({
            phoneNumbers: this.rePwdForm.newphone
        }).then(res=>{
            if(res.code == 20000){
                this.$message('发送成功')
                this.Verification = false //点击button改变v-show的状态
                this.timer = 60
                let auth_timer = setInterval(() => {
                //定时器设置每秒递减
                this.timer-- //递减时间
                if (this.timer <= 0) {
                    this.Verification = true //60s时间结束还原v-show状态并清除定时器
                    clearInterval(auth_timer)
                }
                }, 1000)
            }else{
                this.$message('发送失败')
            }
        }).catch(e=>{
            this.$message('发送失败')
        })

    },
    getData(){
        getUserInfoCW().then(res=>{
            console.log('用户信息'+JSON.stringify(res))
            if(res.code == 20000){
                this.rePwdForm.oldphone = res.data.phone
            }else{
                this.rePwdForm.oldphone = ''
            }
        }).catch(e=>{
            this.rePwdForm.oldphone = ''
        })
    }
  }
}
</script>
<style>
.person-data .cell {
  text-align: center;
}
</style>
<style scoped>
.user-wrap h2 {
  margin: 40px auto;
}
.repwd {
  width: 400px;
}
.repwd-form {
  padding: 0 0 20px 25px;
}
.qrcode {
  padding-left: 25px;
}
.title {
  position: relative;
  margin: 20px 0 30px;
  font-size: 20px;
  font-weight: bold;
  background-color: #f2f2f2;
}
.title .num {
  display: inline-block;
  margin-right: 15px;
  padding: 0 10px;
  color: #fff;
  background-color: #f54737;
}
.user-wrap {
  padding: 30px 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/User.vue